export enum ImageType {
  MAIN = 'main',
  FRONT = 'front',
  REAR = 'rear',
}
